/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    var container = event.target.closest('product-component') || event.target;
    var sizeEl = container.querySelector('[data-aideers-cartbar-size-value]');
    if (sizeEl) {
      sizeEl.textContent = variant.option1;
    }
  });

  document.addEventListener('click', function (event) {
    if (!window.theme || typeof window.theme.isMobile !== 'function' || !window.theme.isMobile()) return;

    var scrollBtn = event.target.closest('[data-cart-bar-scroll]');
    if (!scrollBtn) return;

    var container = scrollBtn.closest('product-component');
    var addToCartBtn = container && container.querySelector('[data-add-to-cart]');
    if (addToCartBtn) {
      event.stopPropagation();
      event.preventDefault();
      addToCartBtn.click();
    }
  }, true);

  // WHY: Wischen, Variantenwechsel und Tastatur aendern nur media--active, sie
  // feuern kein theme:media:select. Zaehler und Thumbnail-Markierung haengen
  // deshalb am Zustand, nicht an einem einzelnen Ereignispfad.
  function syncGalleryState(container) {
    var list = container.querySelector('[data-product-media-list]');
    if (!list) return;

    var slides = list.querySelectorAll('[data-media-id]');
    if (!slides.length) return;

    var index = -1;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('media--active')) {
        index = i;
        break;
      }
    }
    if (index < 0) return;

    var counter = container.querySelector('[data-aideers-counter]');
    if (counter) {
      counter.textContent = (index + 1) + ' / ' + slides.length;
    }

    var activeId = slides[index].getAttribute('data-media-id');
    var thumbs = container.querySelectorAll('[data-thumb-item]');
    for (var t = 0; t < thumbs.length; t++) {
      var link = thumbs[t].querySelector('[data-thumb-link]');
      var isActive = !!link && link.getAttribute('data-media-id') === activeId;
      thumbs[t].classList.toggle('is-active', isActive);
      if (link) link.setAttribute('aria-current', isActive ? 'true' : 'false');
    }
  }

  var productComponents = document.querySelectorAll('product-component');
  for (var c = 0; c < productComponents.length; c++) {
    (function (container) {
      var list = container.querySelector('[data-product-media-list]');
      if (!list) return;

      syncGalleryState(container);

      new MutationObserver(function () {
        syncGalleryState(container);
      }).observe(list, { attributes: true, attributeFilter: ['class'], subtree: true });
    })(productComponents[c]);
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
